
export function addAppResumeEventListener() {
    document.addEventListener("app:resume", handleAppResumeNotification);
}

function handleAppResumeNotification(e) {
    window.location.reload();
}